import * as Sentry from '@sentry/browser';
import abstractInit from 'Utils/sentry/abstractInit';

export const sentryInit = (dsn, options) => abstractInit(Sentry, dsn, options);

export default Sentry;
